var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackSensor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M10,12 C10,13.104 10.896,14 12,14 C13.104,14 14,13.104 14,12 C14,10.897 13.104,10 12,10 C10.896,10 10,10.897 10,12 M8,12 C8,10.142 9.279,8.589 11,8.142 L11,1 C11,0.448 11.447,0 12,0 C12.553,0 13,0.448 13,1 L13,8.142 C14.721,8.589 16,10.142 16,12 C16,14.206 14.206,16 12,16 C9.794,16 8,14.206 8,12 M12,20 C16.411,20 20,16.411 20,12 C20,11.448 19.553,11 19,11 C18.447,11 18,11.448 18,12 C18,15.309 15.309,18 12,18 C8.691,18 6,15.309 6,12 C6,11.448 5.553,11 5,11 C4.447,11 4,11.448 4,12 C4,16.411 7.589,20 12,20 M24,12 C24,18.617 18.617,24 12,24 C5.383,24 0,18.617 0,12 C0,11.448 0.447,11 1,11 C1.553,11 2,11.448 2,12 C2,17.514 6.486,22 12,22 C17.514,22 22,17.514 22,12 C22,11.448 22.447,11 23,11 C23.553,11 24,11.448 24,12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSensor);
export default __webpack_public_path__ + "static/media/black-sensor.c5d7428d4525339bf04bcafa3b96b2ae.svg";
export { ForwardRef as ReactComponent };